export const OTHERS_KEY = `Others${Math.random()}`;
export const TOTAL_KEY = `Total${Math.random()}`;
// derived from colors in chartsView with applied opacity
export const LINE_COLORS = [
  '#a57fdc',
  '#71bef2',
  '#679e9e',
  '#c57598',
  '#fc959a',
  '#97686b',
  '#76b288',
  '#6681c4',
  '#f598c1',
  '#d1b666',
  '#68c4c3',
  '#677d93',
  '#b98866',
  '#caa8ff',
];
